import { useMediaQuery } from '@mui/material';

const useIsTouchDeviceHook = () => useMediaQuery('(max-width: 1024px)');

export default useIsTouchDeviceHook;
